export default __webpack_public_path__ + "static/media/shiba.b67cb703.webp";